import { layoutWorkspace } from '../../../_website/_common/layout.workspace';
import { PageFormToolbar } from '../../../components-common/layout/views/PageFormToolbar';
import { UserGuideCreateForm, UserGuidePage } from '@components-common/support';
import { getGenericMediaSchema } from '../../../components-common/support/schema';

export const userGuideSection = {
  id: 'user-guide',
  path: 'user-guide',
  title: 'User guide',
  layout: layoutWorkspace,
  screens: [
    {
      id: 'index',
      path: '',
      tmp: 'index',
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      Component: UserGuidePage,
    },
    {
      id: 'create',
      title: 'Create New Version',
      path: 'new',
      tmp: 'create',
      roles: ['STUDY_DIRECTOR'],
      left: ['create'],
      Component: PageFormToolbar,
      form: UserGuideCreateForm,
      empty: {
        name: '',
        description: '',
      },
      schema: getGenericMediaSchema(),
    },
  ],
};
